import { Checkbox } from "@material-ui/core";
import React from "react";
import InputMaskCurrency from "../../../../../../components/Input/InputMaskCurrency";

export const tiposModalOrcamento = [
  {
    label: "À vista",
    value: "A_VISTA",
  },
  {
    label: "A prazo",
    value: "A_PRAZO",
  },
];

export const tiposDescontoModalOrcamento = [
  {
    label: "Percentil",
    value: "PERCENTIL",
  },
  {
    label: "Valor",
    value: "VALOR",
  },
];

export const siglaFace = [{
  label: "DISTAL",
  value: " D "
},
{
  label:"OCLUSAL_INCISAL",
  value:" O/I "
},
{
  label:"PALATINA_LINGUAL",
  value:" P/L "
},
{
  label:"MESIAL",
  value:" M "
},
{
  label:"VESTIBULAR",
  value:" V "
},
]

export const concatNomelocal =(face,local)=>{
  const siglaFaces = face?.map((item)=> {
    const face = siglaFace.find((face)=>face.label === item)
    return face.value 
  })  
  return siglaFaces?.length > 0 ? `${local + " - face" + siglaFaces.join(" - ")}` : local
}

export const COLUMNS = ({
  handleCheckAll,
  allCheckBoxChecked,
  handleChangeCheck,
  handleValor,
  isDisabled,
  errors,
  isGerenciadorOrcamento,
  orcamento,
}) => [
  orcamento?.tipo === "ODONTOLOGICO" && {
    Header: (
      <Checkbox
        id="prt-pro-inp-all"
        color="primary"
        checked={allCheckBoxChecked()}
        onChange={() => handleCheckAll()}
        disabled={isDisabled}
      />
    ),
    isClick: true,
    getValue: (row, index) => {
      const { checked } = row;
      return (
        <Checkbox
          id={`prt-pro-inp-chk-${index}`}
          color="primary"
          checked={checked}
          onChange={() => handleChangeCheck(row, index)}
          disabled={isDisabled}
        />
      );
    },
  },
  {
    Header: "Procedimento",
    align: "start",
    getValue: (row) => row.procedimento?.nome,
  },
  orcamento?.tipo === "ODONTOLOGICO" && {
    Header: "Local",
    align: "start",
    getValue: (row) => {
      const face = row.face
      const local = row.dente
        ? row.dente.codigo
        : row.mucosaOral?.descricao;
      return concatNomelocal(face,local);
    },
  },
  (isGerenciadorOrcamento && ({
    Header: "Valor",
    align: "start",
    getValue: (row, index) => {
      const { valorUnitario, checked } = row;
      return <InputMaskCurrency
        id={`prt-pro-inp-vlr-${index}`}
        value={valorUnitario || ""}
        onChange={(e) => handleValor(e.target.value, row)}
        error={checked && !valorUnitario && errors.valor}
      />
    },
  })),
];

export const pageableDefault = {
  pageNumber: 0,
  pageSize: 10,
  sortDir: "DESC",
  sortField: "dataHoraLancamento",
};